import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { StudyGroupChannelsLayout } from "@/features/study-group-channels/components/StudyGroupChannelsLayout";
import { useStudyGroupYourMembership } from "@/hooks/useStudyGroupYourMembership";

export const Route = createFileRoute(
  "/study-group/$study-group-id/stream/channel/$channel-id",
)({
  beforeLoad: ({ params }) => {
    const parsedStudyGroupId = Number(params["study-group-id"]);
    if (!Number.isFinite(parsedStudyGroupId) || parsedStudyGroupId <= 0) {
      throw notFound();
    }

    if (params["channel-id"] === "home") {
      throw redirect({
        to: "/study-group/$study-group-id/stream",
        params: { "study-group-id": params["study-group-id"] },
        replace: true,
      });
    }

    const parsedChannelId = Number(params["channel-id"]);
    if (!Number.isFinite(parsedChannelId) || parsedChannelId <= 0) {
      throw notFound();
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { "study-group-id": studyGroupIdParam, "channel-id": channelId } =
    Route.useParams();

  const parsedStudyGroupId = Number(studyGroupIdParam);
  const studyGroupId =
    Number.isFinite(parsedStudyGroupId) && parsedStudyGroupId > 0
      ? parsedStudyGroupId
      : undefined;
  const parsedChannelId = Number(channelId);
  const normalizedChannelId =
    Number.isFinite(parsedChannelId) && parsedChannelId > 0
      ? String(parsedChannelId)
      : channelId;
  const { canManageMembers, isLoading } = useStudyGroupYourMembership(
    studyGroupId ?? null,
  );

  if (isLoading) {
    return <div className="p-4">Loading...</div>;
  }

  return (
    <StudyGroupChannelsLayout
      studyGroupId={studyGroupId}
      isUserMode={!canManageMembers}
      canManageMembers={canManageMembers}
      initialSelectedChannelId={normalizedChannelId}
      enableRouteSync
    />
  );
}
